export default {
  template: `
    <brands>
      <brands-menu>
        <menu-container selected="accounts"></menu-container>
      </brands-menu>
      <brands-list>
        <brands-list-container
          selected-id="$ctrl.selectedId"
        ></brands-list-container>
      </brands-list>
      <brands-content>
        <brands-users-list-container
          selected-id="$ctrl.selectedId"
        ></brands-users-list-container>
        <brands-permissions-modal-container></brands-permissions-modal-container>
        <brands-revoke-modal-container></brands-revoke-modal-container>
        <brands-admin-settings-modal-container></brands-admin-settings-modal-container>
      </brands-content>
    </brands>
  `,
  bindings: {
    selectedId: '@',
  },
};
